import React from 'react';

const MobileCardList = ({
  children,
  emptyMessage = 'Aucun élément',
  isEmpty = false,
  className = '',
}) => {
  if (isEmpty) {
    return (
      <div className={`mobile-card-list ${className}`}>
        <div className="mobile-card-empty">{emptyMessage}</div>
      </div>
    );
  }

  return <div className={`mobile-card-list ${className}`}>{children}</div>;
};

export default MobileCardList;
